/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchStatusRequestDto
 */
export interface AdminPatchStatusRequestDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof AdminPatchStatusRequestDto
     */
    'exchangeUuid': string;
    /**
     * 환급 상태
     * @type {string}
     * @memberof AdminPatchStatusRequestDto
     */
    'status': AdminPatchStatusRequestDtoStatusEnum;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof AdminPatchStatusRequestDto
     */
    'exchangeCancelOtherReason'?: string;
    /**
     * 환급 불가 사유 id
     * @type {number}
     * @memberof AdminPatchStatusRequestDto
     */
    'exchangeCancelCategoryId'?: number;
}

export const AdminPatchStatusRequestDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type AdminPatchStatusRequestDtoStatusEnum = typeof AdminPatchStatusRequestDtoStatusEnum[keyof typeof AdminPatchStatusRequestDtoStatusEnum];


